export default __webpack_public_path__ + "static/media/tennis-special-cover.cd6b8fdd.png";